/* istanbul ignore file */ export function getAppGalleryPageTitle({ context, isConverged }) {
    return isConverged ? context.loc('MarketplaceAppGallery_pageTitle', 'Browse Apps | Microsoft Marketplace') : context.loc('appGallery_pageTitle', "Business Apps \u2013 Microsoft AppSource");
}
export function getFilteredAppPageTitle({ context, isConverged = false }) {
    return isConverged ? context.loc('MarketplaceFilteredApp_pageTitle', 'Results | Microsoft Marketplace') : context.loc('filteredApp_pageTitle', "All results \u2013 Microsoft AppSource");
}
export function getMyReviewsPageTitle({ context, isConverged }) {
    return isConverged ? context.loc('MarketplaceReview_pageTitle', 'My Reviews | Microsoft Marketplace') : context.loc('review_pageTitle', "My Reviews \u2013 Microsoft AppSource");
}
export function getFeaturedAppsTitle() {
    return 'FeaturedAppsInFilter';
}
